(function () {
  var root = document.querySelector('[id^="ps-"][data-deadline]');
  if (!root) return;
  var FREE = 9000; // seuil livraison offerte, en cents (90 $)
  var cart = null, justAdded = false, busy = false, lastFocus = null;
  function lang() { return document.documentElement.getAttribute('lang') === 'en' ? 'en' : 'fr'; }
  var T = {
    fr: { title: 'Votre panier', added: 'Ajouté au panier', empty: 'Votre panier est vide.', close: 'Fermer', sub: 'Sous-total',
      tax: 'Taxes et livraison calculées à la caisse.', checkout: 'Passer à la caisse', cont: 'Continuer mes achats', rm: 'Retirer',
      more: function (m) { return 'Plus que ' + m + ' pour la livraison offerte'; }, unlocked: 'Livraison offerte débloquée',
      guar: 'Garantie Halloween : commande passée avant le 27 octobre et non livrée avant le 31 = remboursée à 100 %.',
      pack: function (n) { return n + (n > 1 ? ' flacons' : ' flacon'); }, name: null, dec: 'Moins', inc: 'Plus' },
    en: { title: 'Your cart', added: 'Added to cart', empty: 'Your cart is empty.', close: 'Close', sub: 'Subtotal',
      tax: 'Taxes and shipping calculated at checkout.', checkout: 'Checkout', cont: 'Continue shopping', rm: 'Remove',
      more: function (m) { return m + ' away from free shipping'; }, unlocked: 'Free shipping unlocked',
      guar: 'Halloween guarantee: orders placed before October 27 not delivered before October 31 are refunded 100%.',
      pack: function (n) { return n + (n > 1 ? ' bottles' : ' bottle'); }, name: 'Fake blood for car paint', dec: 'Decrease', inc: 'Increase' }
  };
  function money(c) { var v = (c / 100).toFixed(2); return lang() === 'en' ? '$' + v : v.replace('.', ',') + ' $'; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function thumb(u) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=200' : ''; }

  var css = '.psc{position:fixed;left:0;top:0;width:100%;height:100%;z-index:10000;visibility:hidden;pointer-events:none}' +
    '.psc.open{visibility:visible;pointer-events:auto}' +
    '.psc-ov{position:absolute;left:0;top:0;width:100%;height:100%;background:rgba(5,3,3,.72);opacity:0;transition:opacity .25s}' +
    '.psc.open .psc-ov{opacity:1}' +
    '.psc-panel{position:absolute;right:0;top:0;height:100%;width:min(420px,100vw);background:var(--bg2,#140E0E);border-left:1px solid var(--line,#2E2222);display:flex;flex-direction:column;transform:translateX(100%);transition:transform .28s ease;color:var(--txt,#F3EEE6)}' +
    '.psc.open .psc-panel{transform:none}' +
    '.psc-hd{flex:none;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 18px;border-bottom:1px solid var(--line,#2E2222)}' +
    '.psc-ttl{font-family:"Big Shoulders Display",sans-serif;font-weight:900;text-transform:uppercase;font-size:28px;line-height:1}' +
    '.psc-body{flex:1;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:16px 18px;display:flex;flex-direction:column;gap:16px}' +
    '.psc-ship{display:flex;flex-direction:column;gap:8px;font-size:14px;font-weight:600}' +
    '.psc-bar{height:8px;border-radius:4px;background:#2A1D1D;overflow:hidden}' +
    '.psc-bar i{display:block;height:100%;background:var(--ac,#D4202E);border-radius:4px;transition:width .35s ease}' +
    '.psc-it{display:flex;gap:14px;align-items:flex-start;padding:14px 0;border-top:1px solid var(--line,#2E2222)}' +
    '.psc-it img{flex:none;width:72px;height:72px;border-radius:4px;object-fit:cover;background:var(--card,#1A1313);border:1px solid var(--line,#2E2222)}' +
    '.psc-in{flex:1;min-width:0;display:flex;flex-direction:column;gap:4px}' +
    '.psc-nm{font-weight:600;font-size:16px}' +
    '.psc-vr{font-size:13px;color:var(--mut,#B9ADA3)}' +
    '.psc-q{display:flex;align-items:center;gap:10px;margin-top:6px;flex-wrap:wrap}' +
    '.psc-q button.s{width:36px;height:36px;border-radius:4px;border:1px solid #4A3636;background:transparent;color:inherit;font-size:20px;line-height:1;cursor:pointer;padding:0}' +
    '.psc-q span{min-width:20px;text-align:center;font-weight:600}' +
    '.psc-q .psc-rm{background:none;border:0;color:var(--mut,#B9ADA3);text-decoration:underline;font-size:13px;cursor:pointer;padding:4px}' +
    '.psc-pr{flex:none;text-align:right;display:flex;flex-direction:column}' +
    '.psc-pr b{font-family:"Big Shoulders Display",sans-serif;font-weight:800;font-size:24px;line-height:1}' +
    '.psc-pr s{font-size:12px;color:var(--mut,#B9ADA3)}' +
    '.psc-ft{flex:none;padding:16px 18px calc(16px + env(safe-area-inset-bottom));border-top:1px solid var(--line,#2E2222);display:flex;flex-direction:column;gap:10px;background:var(--bg2,#140E0E)}' +
    '.psc-st{display:flex;justify-content:space-between;align-items:baseline;font-weight:600}' +
    '.psc-st b{font-family:"Big Shoulders Display",sans-serif;font-weight:800;font-size:30px}' +
    '.psc-nt{font-size:12px;color:var(--mut,#B9ADA3)}' +
    '.psc-b1,.psc-b2{display:flex;align-items:center;justify-content:center;width:100%;min-height:52px;border-radius:4px;text-decoration:none;cursor:pointer;text-align:center}' +
    '.psc-b1{background:var(--ac,#D4202E);color:#fff!important;border:0;font-family:"Big Shoulders Display",sans-serif;font-weight:800;font-size:24px;letter-spacing:.08em;text-transform:uppercase}' +
    '.psc-b2{background:transparent;color:var(--txt,#F3EEE6);border:1px solid #4A3636;font-size:15px}' +
    '.psc-empty{color:var(--mut,#B9ADA3);text-align:center;padding:40px 0}' +
    '.psc-cb{position:relative}' +
    '.psc-n{position:absolute;right:-6px;top:-6px;min-width:18px;height:18px;padding:0 4px;border-radius:9px;background:var(--ac,#D4202E);color:#fff;font-size:11px;font-weight:600;display:flex;align-items:center;justify-content:center}' +
    '.psc-n[hidden]{display:none}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var X = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var BAG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 7h12l1 13H5zM9 7a3 3 0 0 1 6 0"/></svg>';
  var wrap = document.createElement('div'); wrap.className = 'psc';
  wrap.innerHTML = '<div class="psc-ov" data-psc-close></div><aside class="psc-panel" role="dialog" aria-modal="true" aria-labelledby="psc-title">' +
    '<div class="psc-hd"><h2 class="psc-ttl" id="psc-title"></h2><button type="button" class="ibtn" data-psc-close data-psc-x>' + X + '</button></div>' +
    '<div class="psc-body" data-psc-body></div><div class="psc-ft" data-psc-ft></div></aside>';
  root.appendChild(wrap);
  var panel = wrap.querySelector('.psc-panel'), body = wrap.querySelector('[data-psc-body]'), ft = wrap.querySelector('[data-psc-ft]'),
      ttl = wrap.querySelector('.psc-ttl'), xb = wrap.querySelector('[data-psc-x]');

  var cb = null, badge = null, mb = root.querySelector('[data-menu-btn]');
  if (mb && mb.parentNode) {
    var grp = document.createElement('div'); grp.style.cssText = 'display:flex;gap:8px;align-items:center';
    cb = document.createElement('button'); cb.type = 'button'; cb.className = 'ibtn psc-cb';
    cb.innerHTML = BAG + '<span class="psc-n" hidden></span>';
    badge = cb.querySelector('.psc-n');
    mb.parentNode.insertBefore(grp, mb); grp.appendChild(cb); grp.appendChild(mb);
    cb.addEventListener('click', function () { justAdded = false; render(); openD(); });
  }

  function lineName(it, t) {
    var n = t.name || it.product_title;
    var m = /(\d+)/.exec(it.variant_title || '');
    return { name: n, variant: m ? t.pack(+m[1]) : (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '') };
  }
  function render() {
    var t = T[lang()];
    ttl.textContent = justAdded ? t.added : t.title;
    xb.setAttribute('aria-label', t.close);
    if (cb) cb.setAttribute('aria-label', t.title);
    var count = cart ? cart.item_count : 0;
    if (badge) { badge.textContent = count; if (count) badge.removeAttribute('hidden'); else badge.setAttribute('hidden', ''); }
    if (!count) {
      body.innerHTML = '<p class="psc-empty">' + t.empty + '</p>';
      ft.innerHTML = '<button type="button" class="psc-b2" data-psc-close>' + t.cont + '</button>';
      return;
    }
    var rem = Math.max(0, FREE - cart.total_price), pct = Math.min(100, Math.round(cart.total_price / FREE * 100));
    var h = '<div class="psc-ship"><div>' + (rem > 0 ? t.more(money(rem)) : t.unlocked) + '</div><div class="psc-bar"><i style="width:' + pct + '%"></i></div></div>';
    cart.items.forEach(function (it) {
      var l = lineName(it, t);
      var img = it.featured_image && it.featured_image.url ? '<img src="' + esc(thumb(it.featured_image.url)) + '" alt="" width="72" height="72">' : '';
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      h += '<div class="psc-it" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '">' + img +
        '<div class="psc-in"><div class="psc-nm">' + esc(l.name) + '</div>' + (l.variant ? '<div class="psc-vr">' + esc(l.variant) + '</div>' : '') +
        '<div class="psc-q"><button type="button" class="s" data-act="dec" aria-label="' + t.dec + '">−</button><span>' + it.quantity + '</span><button type="button" class="s" data-act="inc" aria-label="' + t.inc + '">+</button><button type="button" class="psc-rm" data-act="rm">' + t.rm + '</button></div></div>' +
        '<div class="psc-pr"><b>' + money(it.final_line_price) + '</b>' + was + '</div></div>';
    });
    h += '<p class="psc-nt">' + t.guar + '</p>';
    body.innerHTML = h;
    ft.innerHTML = '<div class="psc-st"><span>' + t.sub + '</span><b>' + money(cart.total_price) + '</b></div><div class="psc-nt">' + t.tax + '</div>' +
      '<a class="psc-b1" href="/checkout">' + t.checkout + '</a><button type="button" class="psc-b2" data-psc-close>' + t.cont + '</button>';
  }
  function openD() {
    lastFocus = document.activeElement; wrap.classList.add('open'); document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { var f = ft.querySelector('.psc-b1') || xb; if (f) f.focus(); }, 60);
  }
  function closeD() {
    wrap.classList.remove('open'); document.documentElement.style.overflow = ''; justAdded = false;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function change(key, q) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (c) { cart = c; justAdded = false; render(); })
      .catch(function () { return getCart().then(function (c) { cart = c; render(); }); });
  }

  wrap.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el !== wrap) {
      if (el.hasAttribute && el.hasAttribute('data-psc-close')) { closeD(); return; }
      var a = el.getAttribute && el.getAttribute('data-act');
      if (a) {
        var row = el.closest('.psc-it'); if (!row) return;
        var q = +row.getAttribute('data-q'), key = row.getAttribute('data-key');
        change(key, a === 'inc' ? q + 1 : a === 'dec' ? Math.max(0, q - 1) : 0);
        return;
      }
      el = el.parentNode;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && wrap.classList.contains('open')) closeD(); });
  new MutationObserver(function () { render(); }).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form.ps-form')) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    var id = new FormData(f).get('id');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(getCart)
      .then(function (c) { cart = c; justAdded = true; render(); openD(); busy = false; })
      .catch(function () { busy = false; f.submit(); });
  }, true);

  getCart().then(function (c) { cart = c; render(); }).catch(function () {});
})();